import { apiClient, handleApiRequest } from './client'

export interface DirectAssignTeacher {
  id: string
  last_name: string
  first_name: string
  teacher_code: string | null
  display_name: string
  quali?: 'all' | 'some' | 'none' | null
  matched?: number
  total?: number
  subjects?: { label: string; ok: boolean }[]
}

export interface DirectAssignSlot {
  id: string
  slot_number: number
  name?: string | null
  start_time: string
  end_time: string
}

export interface DirectAssignLesson {
  entry_id: string
  time_slot_id: string | null
  slot_name?: string | null
  slot_number?: number
  start_time?: string
  end_time?: string
  subject_name: string | null
  room_name: string | null
  klass_name: string | null
  occupancy: 'none' | 'open_search' | 'booked'
  substitution_excluded?: boolean
  occupancy_request_id: string | null
  occupancy_status: string | null
  booked_teacher_id: string | null
  booked_teacher_name: string | null
}

export interface DirectAssignDay {
  date: string
  weekday: number
  iso_week: number
  is_school_day: boolean
  is_holiday: boolean
  is_weekend: boolean
  in_range: boolean
  lessons: DirectAssignLesson[]
}

export interface DirectAssignGrid {
  from: string
  to: string
  today: string
  saturday: boolean
  slots: DirectAssignSlot[]
  days: DirectAssignDay[]
}

export interface DirectAssignPosition {
  date: string
  time_slot_id: string
  original_entry_id: string
  substitute_teacher_id?: string | null
}

export const adminDirectAssignApi = {
  listTeachers: (q?: string, excludeTeacherId?: string) =>
    handleApiRequest<{ teachers: DirectAssignTeacher[] }>(
      apiClient.get('/api/v1/admin/direct-assign/teachers', {
        params: {
          ...(q ? { q } : {}),
          ...(excludeTeacherId ? { exclude_teacher_id: excludeTeacherId } : {}),
        },
      }),
    ),
  grid: (teacherId: string, from: string, to: string) =>
    handleApiRequest<DirectAssignGrid>(
      apiClient.get(`/api/v1/admin/direct-assign/teachers/${teacherId}/grid`, {
        params: { from, to },
      }),
    ),
  candidates: (payload: {
    exclude_teacher_id: string
    q?: string
    positions: DirectAssignPosition[]
    preview_teacher_id?: string | null
    preview_entry_ids?: string[]
  }) =>
    handleApiRequest<{ teachers: DirectAssignTeacher[]; lesson_ok: Record<string, boolean> }>(
      apiClient.post('/api/v1/admin/direct-assign/candidates', payload),
    ),
  hints: (teacherId: string, positions: DirectAssignPosition[]) =>
    handleApiRequest<{ teacher_id: string; warnings: string[]; blocks: boolean }>(
      apiClient.post('/api/v1/admin/direct-assign/hints', {
        teacher_id: teacherId,
        positions,
      }),
    ),
  commit: (payload: {
    from: string
    to: string
    absent_teacher_id: string
    positions: DirectAssignPosition[]
    start_search?: boolean | null
    conflicts?: { date: string; time_slot_id: string; original_entry_id: string; action: 'overwrite' | 'skip' }[]
  }) =>
    handleApiRequest<{
      request_id: string
      status: string
      lessons_filled: number
      total_lessons: number
      search_started: boolean
      combo_search_pending: boolean
    }>(apiClient.post('/api/v1/admin/direct-assign/commit', payload)),
}
